import React from "react";
import PropTypes from "prop-types";
import { PrimaryButton, ButtonLink } from "../../../../components/Buttons";

import {
  W3Dropdown,
  W3DropdownToggler,
  W3DropdownContent,
} from "../../../../components/W3Dropdown";
import ITTaskDialog from "./ITTaskDialog";
import ActionFilter from "../ActionFilter";
import { filterTasksByTaskType, isDeletionTask } from "../Utils";

export default function ADConnectionTaskMenu({
  className = "",
  items = [],
  filterConnections,
  connectionTaskType,
  selectedADConnections,
  exportADConnections,
  closeADConnectionTasks,
}) {
  const taskDialogRef = React.useRef(null);

  const onExport = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      const type = "AD";
      let counter = 0;
      if (selectedADConnections && selectedADConnections.length > 0) {
        counter += selectedADConnections.length;
      }
      const isSingular = counter === 1;
      taskDialogRef.current.show(
        true,
        {
          title: `Vodafone Accounts exportieren`,
          text: `
          ${isSingular ? "Der" : "Alle " + counter} ausgewählte Vodafone ${isSingular ? "Account wird" : "Accounts werden"} für die  
          Weiterverarbeitung vorbereitet und als CSV exportiert. Wollen Sie fortfahren?
        `,
          type: type.toUpperCase(),
          showValidity: false,
          taskType: connectionTaskType,
          showTaskType: false,
        },
        (data) => exportADConnections(data),
      );
    },
    [selectedADConnections, exportADConnections],
  );

  const closeableConnections = React.useMemo(() => {
    if (isDeletionTask(connectionTaskType) && selectedADConnections) {
      return selectedADConnections.filter((item) =>
        filterTasksByTaskType(item, connectionTaskType),
      );
    }
    return [];
  }, [connectionTaskType, selectedADConnections]);
  
  const onClose = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      const type = "AD";
      let counter = 0;

      if (closeableConnections && closeableConnections.length > 0) {
        counter += closeableConnections.length;
      }
      const isSingular = counter === 1;
      taskDialogRef.current.show(
        true,
        {
          title: `Vodafone Accounts schließen`,
          text: `
          ${isSingular ? "Der" : "Alle " + counter} ausgewählte Vodafone ${isSingular ? "Account wird" : "Accounts werden"} nun geschlossen.  
          Wollen Sie fortfahren?
        `,
          type: type.toUpperCase(),
          showValidity: false,
          taskType: connectionTaskType,
          showTaskType: false,
        },
        (_data) => closeADConnectionTasks(closeableConnections),
      );
    },
    [closeableConnections, closeADConnectionTasks, connectionTaskType],
  );

  const isADExportable = selectedADConnections && selectedADConnections.length > 0;
  const isCloseable = closeableConnections && closeableConnections.length > 0;

  return (
    <div className={className}>
      <div className="w3-cell-row">
        <div className="w3-cell w3-cell-middle pad-rht">
          <ActionFilter
            type="AD"
            taskType={connectionTaskType}
            setTaskType={filterConnections}
            itemsToCount={items}
            className="display-inline-block"
          />
        </div>
        <div className="w3-cell w3-cell-middle pad-lft">
          <W3Dropdown className="modems dropdown-list-menu">
            <W3DropdownToggler
              as={PrimaryButton}
              size=""
            >{`Optionen`}</W3DropdownToggler>
            <W3DropdownContent
              className="w3-bar-block w3-border"
              style={{ right: "0", width: "320px" }}
            >
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onExport}
                disabled={!isADExportable}
              >
                {`Vodafone Accounts exportieren (CSV)`}
              </ButtonLink>
              <ButtonLink
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                to={`/wizard/aufgabe/import/vodafone-account`}
                disabled={false}
              >
                {`Vodafone Accounts importieren (CSV)`}
              </ButtonLink>
              <a href="#" className="w3-bar-item separator">
                <div className="w3-border-top" style={{ margin: "0 -4px" }} />
              </a>
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onClose}
                disabled={!isCloseable}
              >
                {`Vodafone Accounts schließen`}
              </ButtonLink>
            </W3DropdownContent>
          </W3Dropdown>
        </div>
      </div>
      <ITTaskDialog ref={taskDialogRef} />
    </div>
  );
}

ADConnectionTaskMenu.propTypes = {
  className: PropTypes.string,
  selectedADConnections: PropTypes.array,
  connectionTaskType: PropTypes.string,
  exportADConnections: PropTypes.func.isRequired,
  closeADConnectionTasks: PropTypes.func.isRequired,
  filterConnections: PropTypes.func.isRequired,
  items: PropTypes.array,
  history: PropTypes.object,
};
